export const BILLING_STATUS = [
  {
    value: 'cancel,canceled,declined,error,failed,no-payment,not-paid,rejected',
    label: 'Not Paid',
  },
  {
    value: 'paid,succeeded,success,successful',
    label: 'Paid',
  },
  {
    value:
      'payment-processing,incomplete,pending,waiting,requires_payment_method,requires_capture,requires_confirmation,requires_action,processing',
    label: 'Pending',
  },
  {
    value: 'sent',
    label: 'Sent',
  },
  {
    value: 'unknown',
    label: 'Unknown',
  },
];
